import axios from 'axios';

import { getEnv } from '@/app/conf/env';
import { endUserSession, getTokens, setTokens } from '@/shared/auth/user-store';
import {
  createAuthRequestInterceptor,
  createRefreshTokenCoordinator,
  unwrapResponseData
} from '@/shared/axios';

import { refreshAuthToken } from './auth-token';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers['Accept'] = 'application/json';
axios.defaults.headers['X-Firefly-Client'] = 'Web';

const refreshTokenCoordinator = createRefreshTokenCoordinator({
  refreshTokenFn: refreshAuthToken,
  getTokens,
  setTokens,
  endUserSession
});

/**
 * An Axios instance configured for interacting with the Firefly API.
 */
export const fireflyApi = axios.create({
  baseURL: getEnv().FIREFLY_API_URL
});
fireflyApi.interceptors.request.use(createAuthRequestInterceptor(getTokens));
fireflyApi.interceptors.response.use(
  unwrapResponseData,
  refreshTokenCoordinator.createErrorHandler(fireflyApi)
);

/**
 * An Axios instance configured for interacting with the Firefly API.
 */
export const fireflyApi3 = axios.create({
  baseURL: getEnv().FIREFLY_API_V3_URL
});
fireflyApi3.interceptors.request.use(createAuthRequestInterceptor(getTokens));
fireflyApi3.interceptors.response.use(
  unwrapResponseData,
  refreshTokenCoordinator.createErrorHandler(fireflyApi3)
);

/**
 * Axios instance configured for interacting with the Firefly Apply API.
 *
 * NOTE - Will be deprecated in V3 API
 */
export const fireflyApplyApi = axios.create({
  baseURL: getEnv().FIREFLY_APPLY_API_URL
});

fireflyApplyApi.interceptors.request.use(createAuthRequestInterceptor(getTokens));
fireflyApplyApi.interceptors.response.use(
  unwrapResponseData,
  refreshTokenCoordinator.createErrorHandler(fireflyApplyApi)
);
